<!-- Uses the burgerprofiel CSS. -->
<div class="vlw__profile__toggle-wrapper vlw__profile__toggle__name">
    {{ content() }}
    <a
        class="vlw__profile__toggle__name__capacity"
        style="cursor: pointer"
        (click)="logOff()"
        (keydown.enter)="logOff()"
        aria-label="Uitloggen"
        title="Uitloggen"
        tabindex="0"
    >
        Uitloggen
    </a>
</div>
